
import './input-button.scss';
//library
import { useState } from 'react';
//shared
import ITextField from '../../interfaces/text-field.interface';
import IButtonData from '../../interfaces/button.interface';
//material
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';

export const InputButton = ({ buttonData, textFieldData, buttonClick }: { buttonData: IButtonData, textFieldData: ITextField, buttonClick: (data: number | string) => void }) => {
    const [value, setValue] = useState('');

    const changeIpunt = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
        if(!textFieldData.showButton) buttonClick(event.target.value);
    };

    return (
        <div className={textFieldData.style ? textFieldData.style : "button-input"}>
            <TextField
                id={textFieldData.id}
                label={textFieldData.label}
                variant={textFieldData.variant}
                type={textFieldData.type}
                onChange={changeIpunt} />
            {textFieldData.showButton && (
                <Button
                    key={buttonData.id}
                    variant={buttonData.variant}
                    color={buttonData.color}
                    size={buttonData.size}
                    onClick={() => buttonClick(value)}
                    className='button'
                >
                    {buttonData.textButton}
                </Button>
            )}
        </div>
    )
}